<template>
    <v-chip-group :value="value" mandatory column active-class="primary--text" @change="onChange">
        <v-chip v-for="view in views" :key="view.value" :value="view.value" small filter
            filter-icon="fas fa-check" outlined>
            <v-icon v-if="view.icon" left x-small>{{ view.icon }}</v-icon>{{ view.label }}
        </v-chip>
    </v-chip-group>
</template>
<script>
/**
 * Vistas rápidas: atajos de un clic, una activa a la vez.
 *
 *   <QuickViews v-model="vista" :views="[{ value: 'all', label: 'Todas' }, ...]" />
 *
 * `mandatory` garantiza que siempre haya una activa; volver a pulsar la
 * activa no la apaga.
 */
export default {
    name: 'QuickViews',
    props: {
        views: { type: Array, required: true },
        value: { type: [String, Number], default: null }
    },
    methods: {
        onChange(value) {
            // Vuetify emite undefined un instante al re-seleccionar.
            if (value !== undefined && value !== this.value) this.$emit('input', value);
        }
    }
}
</script>
